var moduleMap = {
	"./CustomerContext": () => {
		return __webpack_require__.e(645).then(() => (() => ((__webpack_require__(1645)))));
	},
	"./Customers": () => {
		return __webpack_require__.e(80).then(() => (() => ((__webpack_require__(3080)))));
	},
	"./Customer": () => {
		return __webpack_require__.e(345).then(() => (() => ((__webpack_require__(1345)))));
	},
	"./PrimaryDocSelection": () => {
		return __webpack_require__.e(297).then(() => (() => ((__webpack_require__(297)))));
	},
	"./InterstateLicence": () => {
		return __webpack_require__.e(614).then(() => (() => ((__webpack_require__(6614)))));
	},
	"./SecondaryDocSelection": () => {
		return __webpack_require__.e(877).then(() => (() => ((__webpack_require__(3877)))));
	},
	"./Passport": () => {
		return __webpack_require__.e(352).then(() => (() => ((__webpack_require__(2352)))));
	},
	"./Visa": () => {
		return __webpack_require__.e(937).then(() => (() => ((__webpack_require__(8937)))));
	},
	"./BirthCertificate": () => {
		return __webpack_require__.e(190).then(() => (() => ((__webpack_require__(5190)))));
	},
	"./Citizenship": () => {
		return __webpack_require__.e(952).then(() => (() => ((__webpack_require__(7952)))));
	},
	"./ImmiCard": () => {
		return __webpack_require__.e(132).then(() => (() => ((__webpack_require__(5132)))));
	},
	"./MedicareCard": () => {
		return __webpack_require__.e(147).then(() => (() => ((__webpack_require__(4147)))));
	},
	"./NonDVSGroup3DocumentsPage": () => {
		return __webpack_require__.e(701).then(() => (() => ((__webpack_require__(5701)))));
	},
	"./FirstCredentialUploadSuccess": () => {
		return __webpack_require__.e(448).then(() => (() => ((__webpack_require__(6448)))));
	},
	"./SecondCredentialUploadSuccess": () => {
		return __webpack_require__.e(633).then(() => (() => ((__webpack_require__(8633)))));
	},
	"./ThirdCredentialUploadSuccess": () => {
		return __webpack_require__.e(525).then(() => (() => ((__webpack_require__(2525)))));
	},
	"./NameChangeDocSelection": () => {
		return __webpack_require__.e(529).then(() => (() => ((__webpack_require__(3529)))));
	},
	"./ChangeOfNameCertificate": () => {
		return __webpack_require__.e(465).then(() => (() => ((__webpack_require__(7465)))));
	},
	"./MarriageCertificate": () => {
		return __webpack_require__.e(556).then(() => (() => ((__webpack_require__(8556)))));
	},
	"./ExemptNameChange": () => {
		return __webpack_require__.e(978).then(() => (() => ((__webpack_require__(8978)))));
	},
	"./NonDvsNameChangeGroupPage": () => {
		return __webpack_require__.e(287).then(() => (() => ((__webpack_require__(1287)))));
	},
	"./NameChangeDocUploadSuccess": () => {
		return __webpack_require__.e(999).then(() => (() => ((__webpack_require__(999)))));
	},
	"./TransactionHistory": () => {
		return __webpack_require__.e(344).then(() => (() => ((__webpack_require__(6344)))));
	},
	"./NameConfirmation": () => {
		return __webpack_require__.e(137).then(() => (() => ((__webpack_require__(9137)))));
	},
	"./ThirdDocSelection": () => {
		return __webpack_require__.e(924).then(() => (() => ((__webpack_require__(4924)))));
	},
	"./QLDDocuments": () => {
		return __webpack_require__.e(40).then(() => (() => ((__webpack_require__(8278)))));
	},
	"./NonDVSGroup1Documents": () => {
		return __webpack_require__.e(451).then(() => (() => ((__webpack_require__(2451)))));
	},
	"./NonDVSGroup2Documents": () => {
		return __webpack_require__.e(420).then(() => (() => ((__webpack_require__(2420)))));
	},
	"./OverseasMarriageCertificate": () => {
		return __webpack_require__.e(562).then(() => (() => ((__webpack_require__(562)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});